import { Injectable } from '@angular/core';
import { EntitySavedEventArgs } from '@m4u-angular/base/classes/BaseClasses';
import { BaseEntity } from '@m4u-angular/base/entities/BaseEntities';

export class SavedEntityInfo {
    public Entity: BaseEntity;
    public Type: new () => BaseEntity;
    public Field: string;
}

@Injectable({
    providedIn: 'root'
})
export class EntityService {

    private _savedEntity: SavedEntityInfo;
    private _isEnabled: boolean;
    private _field: string;

    constructor() {}

    Activate(field?: string) {
        if (!this._isEnabled) this._isEnabled = true;
        this._field = field;
    }

    SetLastSavedEntity(entitySavedArgs: EntitySavedEventArgs) {
        if (!this._isEnabled) return;

        this._savedEntity = new SavedEntityInfo();
        this._savedEntity.Entity = entitySavedArgs.Entity;
        this._savedEntity.Type = entitySavedArgs.Type;
        this._savedEntity.Field = this._field;
    }

    GetLastSavedEntity(field?: string, type?: new () => BaseEntity): SavedEntityInfo {
        if (!this._isEnabled) return new SavedEntityInfo;
        if ((field && this._savedEntity?.Field != field) || (type && this._savedEntity.Type != type)) {
            return;
        }

        const entity = { ...this._savedEntity };
        this.Deactivate();
        
        return entity;
    }

    private Deactivate() {
        this._savedEntity = null;
        this._isEnabled = false;
        this._field = null;
    }
}